<template>
  <div>
    <div class="report" v-if="showReport">
      <p class="mdl-typography--text-center">Da clic en alguna de las siguientes opciones para visualizar el <u>reporte de auditoría</u> al inmueble <strong>{{ audit.inmueble }}</strong></p>
      <p class="mdl-typography--text-center">
        <button class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored"
          @click="downloadReport">Descargar Reporte</button>
        <button class="mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--colored"
          @click="showReportOnScreen">Visualizar en Página</button>
      </p>
      <progress-bar v-show="showProgress"></progress-bar>
      <iframe id="iframeid" v-show="reportLoaded" :src="reportSrc" width="100%" height="100%"
        @load="showReportOnScreenEnd"></iframe>
    </div>

    <div class="incidences" v-else>
      <header>
        <div class="card-cover mdl-card mdl-shadow--2dp">
          <div class="mdl-card__media"
            :style="{ background: 'url(' + audit.cover + ') center / cover' }"></div>
          <div :class="['mdl-card__title', audit.promedio ? ( audit.promedio >= audit.aceptable ? 'bg-green' : ( audit.promedio > audit.inaceptable ? 'bg-yellow' : 'bg-red' )) : 'bg-grey']">
            <div class="mdl-card__title_1">
              <!-- <div class="mdl-card__title-media">
                <img :src="audit.thumbnail">
              </div> -->
              <h2 class="mdl-card__title-text">
                <strong>{{ audit.inmueble }}</strong>
                <small>{{ audit.empresa }}</small>
              </h2>
            </div>
            <div class="mdl-card__title_2">
              <div class="mdl-card__helper">
                <strong>{{ audit.incidencias }}</strong>
                <small>Incidencias</small>
              </div>
              <div class="mdl-card__helper">
                <strong>{{ audit.promedio ? audit.promedio : 'N / A' }}</strong>
                <small>Puntos</small>
              </div>
              <div class="mdl-card__helper">
                <small>{{ audit.statusNombre.toUpperCase() }}</small>
              </div>
            </div>
          </div>
          <div v-for="responsable in audit.mantenimiento" class="mdl-card__supporting-text">
            <div class="minilogo"
                  :style="{backgroundImage: 'url(' + responsable.avatar + ')' }"></div>
            <!-- <img class="avatar"
                  src=""
                  alt="Imagen del Encargado de Mantenimiento"> -->
            <div class="flex-grow-2">
              <strong>{{ responsable.nombre }}</strong>
              <span>Responsable de Mantenimiento</span>
            </div>
            <div>
              <!-- <span>{{ tree.inmueble.mantenimiento.since }}</span> -->
            </div>
          </div>
        </div>
      </header>
      <main>
        <div v-for="(incidencia, i) in incidencias" class="card-main mdl-card mdl-shadow--2dp">
          <div class="mdl-card__title">
            <h2 class="mdl-card__title-text">
              <strong>{{ incidencia.area }}</strong>
              <small>{{ incidencia.rubro }}</small>
            </h2>
            <div class="mdl-card__helper">
              <small>{{ incidencia.especificacion.toUpperCase() }}</small>
              <button type="button" :class="['current-chip', 'mdl-chip',
                'mdl-color--' + incidencia.color]"></button>
            </div>
          </div>
          <div class="mdl-card__media">
            <div class="mdl-card mdl-shadow--2dp"
              v-for="(imagen, k) in incidencia.imagenes.split(',')"
              :style="{ background: 'url(' + incidencia.origen + imagen + ') center / cover' }"
              :key="k">
              <div class="mdl-card__title mdl-card--expand"></div>
              <div class="mdl-card__actions">
                <span class="mdl-card__filename">
                  {{ 'Imagen #' + (k+1) + ' de la incidencia.' }}
                </span>
              </div>
              <div class="mdl-card__menu" style="left: 16px;">
                <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
                  :data-i="i" :data-k="k" @click="downloadPicture">
                  <i class="material-icons">file_download</i>
                </button>
              </div>
            </div>
          </div>
          <div class="mdl-card__supporting-text">
            <div class="mdl-card__previus">
              <div class="minilogo"
                    :style="{backgroundImage: 'url(' + '' + ')' }"></div>
              <span>{{ incidencia.observaciones }}</span>
            </div>

            <div v-if="!incidencia.aprobada" class="revaluacion">
              <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" :for="'checkbox-' + i">
                <input type="checkbox" :id="'checkbox-' + i" class="mdl-checkbox__input"
                  @change="incidencia.revaluacion.aprobado = !$event.target.checked">
                <span class="mdl-checkbox__label">Reevaluar Incidencia</span>
              </label>

              <div class="mdl-card__additional-text" v-show="!incidencia.revaluacion.aprobado">
                <img :src="$user.data.avatar || './img/profile-64.png'" class="avatar">
                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                  <textarea class="mdl-textfield__input" type="text" rows= "3"
                    v-model="incidencia.revaluacion.observaciones"></textarea>
                  <label class="mdl-textfield__label">Escribe tus observaciones aquí...</label>
                </div>
              </div>
            </div>
            <div v-else class="bg-green-light" style="padding: 0.5rem">
              <p style="margin:0">Esta incidencia ya fue aprobada.</p>
            </div>
          </div>
          <!-- <div class="mdl-card__actions mdl-card--border">
            <button class="mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--colored"
              :disabled="incidencia.aprobada" @click="aprobarIncidencia" :data-i="i">
              Aprobar
            </button>
          </div> -->
        </div>

        <div v-show="incidencias.length === 0" style="text-align:center">
          <h4>Todas las incidencias fueron calificadas en VERDE.</h4>
          <p>Es necesario <strong>Enviar la Evaluación</strong> para expresar su consentimiento.</p>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Progress from '@/components/Shared/Progress/'

export default {
  components: {
    'progress-bar': Progress
  },
  props: ['audit'],
  data () {
    return {
      title: 'Reporte de Auditoría',
      reportSrc: '',
      reportLoaded: false,
      incidencias: false,
      showReport: true,
      showProgress: false,
      points: 0,
      actionbar: {
        true: {
          show: true,
          buttons: [
            {
              text: 'Regresar',
              onclick: () => {
                this.$emit('showNewsfeed', true)
              }
            }
          ]
        },
        false: {
          show: true,
          buttons: [
            {
              text: 'Regresar',
              onclick: () => {
                this.showReport = !this.showReport
              }
            }
          ]
        }
      }
    }
  },
  watch: {
    showReport () {
      this.$actionbar.init(this.actionbar[this.showReport])
    }
  },
  methods: {
    downloadReport () {
      window.open(this.$http.defaults.baseURL + '/auditoria/pdf/' +
        this.audit.id + '/' + this.$user.data.id)
    },
    showReportOnScreen () {
      if (this.reportSrc !== '') {
        document.getElementById('iframeid').src += ''
        this.reportLoaded = false
      }

      this.showProgress = true
      this.reportSrc = this.$http.defaults.baseURL + '/auditoria/pdf/' +
        this.audit.id + '/' + this.$user.data.id
    },
    showReportOnScreenEnd () {
      if (this.reportSrc === '') return
      this.showProgress = false
      this.reportLoaded = true
    },
    downloadPicture (event) {
      let downloadButton = event.currentTarget,
          i = downloadButton.dataset.i,
          k = downloadButton.dataset.k,
          incidencia = this.incidencias[i],
          imagenes = incidencia.imagenes.split(','),
          anchor = document.createElement('a')
          // url = imagenes[k].replace(/^data:image\/[^;]+/, 'data:application/octet-stream'),
          // win = window.open(imagenes[k], '_blank')

      anchor.href = 'https://appauditoria.gtglobal.com/storage/auditorias/' + imagenes[k]
      anchor.target = '_blank'
      anchor.download = this.audit.inmueble + '__' +
        incidencia.area + '__' +
        incidencia.rubro + '__' +
        incidencia.especificacion + '__' +
        imagenes.length

      return anchor.click()


      // image.src = imagenes[k]

      // return win.document.write(image.outerHTML)
      // return window.open(imagenes[k], '_blank')
    }
  },
  mounted () {
    if (this.audit.statusId === 1) {
      const loadButton = {
        text: 'Ver Incidencias',
        onclick: () => {
          this.showReport = false
          this.$http.get('incidencias/' + this.audit.id)
            .then(response => {
              let data = response.data
              data.forEach(d => {
                d.revaluacion = {
                  aprobado: true,
                  observaciones: ''
                }
              })

              this.incidencias = data
            }).then(() => {
              componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-checkbox'))
              componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-textfield'))
              componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-button'))

              this.$emit('showProgress', false)
            })
          this.$emit('showProgress', true)
        }
      }, sendButton = {
        text: 'Enviar Evaluación',
        onclick: () => {
          const checkedBoxes = document.querySelectorAll('.mdl-checkbox__input:checked')

          for (let i = 0; i < checkedBoxes.length; i++) {
            let parent = checkedBoxes[i].parentNode
            while (!parent.classList.contains('revaluacion')) {
              parent = parent.parentNode
            }

            if (parent.querySelector('.mdl-textfield__input').value === '') {
              return this.$toast.show('Favor de escribir tu REVALUACION en cada incidencia.')
            }
          }

          this.$dialog.accept = () => {
            this.$http.post('aprobacion', {
              'auditoria_id': this.audit.id,
              'incidencias': this.incidencias
            }).then(response => {
              if (response.data.status === 'OK') {
                this.$http.post('auditoria/notify', {
                  type: 'jefe-auditoria',
                  username: this.$user.data.name,
                  inmueble: this.audit.inmueble,
                  statusId: response.data.auditoria.statusId
                }).then(response => {
                  // console.log(response)
                })

                this.$toast.show('¡Auditoría evaluada con éxito!')
                this.$emit('showNewsfeed', true)
              }
            }).then(() => {
              this.$loading.hide()
            })

            this.$loading.show()
            this.$toast.show('Enviando evaluación de la auditoría...')
          }

          this.$dialog.show('Enviar Evaluación',
            'Estás a punto de enviar la evaluación de esta auditoría. Si por lo menos existe' +
            ' una INCIDENCIA para reevaluar, la auditoría obtendrá el estatus de REEVALUACION.' +
            ' Por el contrario, se tomará como auditoría APROBADA, ¿deseas continuar?')
        }
      }

      this.actionbar.true.buttons.push(loadButton)
      this.actionbar.false.buttons.push(sendButton)
    }

    this.$endpoint.destroy()
    this.$actionbar.init(this.actionbar.true)
    this.$title.show(this.title + ': ' + this.audit.inmueble)

    componentHandler.upgradeElements(this.$el.querySelectorAll('.mdl-button'))
  }
}
</script>

<style lang="css" scoped>
  .report iframe {
    height: calc(100vh - 64px - 16px - 40px - 52px - 60px - 24px);
  }

  .incidences {
    width: 100%;
  }

  .incidences header {
    width: 100%;
    margin: 0;
  }

  .card-cover,
  .card-main {
    width: 100%;
    min-height: 150px;
    margin: 1rem 0;
    color: #fff !important;
    opacity: 1;
  }

  .card-cover .mdl-card__media {
    position: absolute;
    left: 0;
    width: 100%;
    /*height: 200px;*/
    background-position-y: 80%;
    -webkit-filter: blur(3px);
    -moz-filter: blur(3px);
    -o-filter: blur(3px);
    -ms-filter: blur(3px);
    filter: blur(3px);
    z-index: -1;
  }

  .card-cover .mdl-card__title {
    position: relative;
    height: 150px;
    flex-direction: column;
    background: #bebebe
  }

  .card-cover .mdl-card__title * {
   color: #fff !important;
   opacity: 1;
  }

  .card-cover .mdl-card__title .mdl-card__title_1 {
    padding-left: 1rem;
  }

  .card-cover .mdl-card__title .mdl-card__title_1,
  .card-cover .mdl-card__title .mdl-card__title_2 {
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .card-cover .mdl-card__title .mdl-card__title_2 {
    position: absolute;
    bottom: 0;
  }

  .card-cover .mdl-card__title .mdl-card__title-media,
  .card-main .mdl-card__title .mdl-card__title-media {
    margin: 0 10px;
    align-self: flex-end;
  }

  .card-cover .mdl-card__title .mdl-card__title-media img {
    width: 80px;
  }

  .card-cover .mdl-card__title .mdl-card__title-text,
  .card-main .mdl-card__title .mdl-card__title-text {
    flex-grow: 2;
    margin-bottom: 10px;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .card-cover .mdl-card__title .mdl-card__title-text > span {
    font-size: 1.25rem;
  }

  .card-cover .mdl-card__title .mdl-card__helper {
    position: relative;
    /*bottom: -32px;*/
    min-height: 65px;
    flex-grow: 2;
    margin: 20px;
    margin-bottom: 0;
    padding: 10px;
    border-radius: 5px 5px 0 0;
    align-self: flex-end;
    text-align: center;
    line-height: 1.25;
    opacity: 0.85;
  }

  .card-cover .mdl-card__title .mdl-card__helper:last-child {
    height: 45%;
  }

  .card-cover .mdl-card__title .mdl-card__helper strong {
    display: block;
    font-size: 1.5rem;
    font-weight: bolder;
  }

  .card-cover .mdl-card__title .mdl-card__helper small {
    font-size: 0.75rem;
    font-weight: bold;
    text-transform: uppercase;
  }

  .card-cover .mdl-card__supporting-text {
    width: 100%;
    height: auto;
    background: #fff;
    z-index: 1;

    box-sizing: border-box;
    padding: 16px;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-justify-content: flex-start;
    -ms-flex-pack: start;
    justify-content: flex-start;
  }

  .card-cover .mdl-card__supporting-text > * {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .card-cover .mdl-card__supporting-text > *:first-child {
    margin-right: 16px;
  }

  .card-cover .mdl-card__supporting-text .minilogo {
    width: 44px;
    height: 44px;
    background-position: center;
    background-repeat: no-repeat;
    /* background-size: 50%; */
    border-radius: 22px;
    background-color: #F5F5F5;
  }

  .card-cover .mdl-card__supporting-text strong {
    font-weight: bold;
  }

  .card-cover .flex-grow-2 {
    flex-grow: 2;
  }

  .card-main .mdl-card__title {
    padding: 0.5rem 2rem;
  }

  .card-main .mdl-card__title .mdl-card__helper {
    display: flex;
  }

  .card-main .mdl-card__title .mdl-card__helper > small {
    padding: 8px;
  }

  .card-main .mdl-card__title .mdl-card__helper > button {
    width: 32px;
    cursor: pointer;
  }

  .card-main .mdl-card__media {
    display: flex;
    flex-wrap: wrap;
    background-color: #f3f3f3;
  }

  .card-main .mdl-card__media .mdl-card {
    width: 256px;
    height: 256px;
    margin: 5px auto;
    /*background: url('../assets/demos/image_card.jpg') center / cover;*/
    /*background-position: center;
    background-repeat: cover;*/
  }

  .card-main .mdl-card__media .mdl-card__actions {
    height: 52px;
    padding: 16px;
    background: rgba(0, 0, 0, 0.2);
  }

  .card-main .mdl-card__media .mdl-card__filename {
    color: #fff;
    font-size: 14px;
    font-weight: bold;
  }

  .card-main .mdl-card__supporting-text {
    width: 100%;
  }

  .card-main .mdl-card__supporting-text .mdl-card__previus {
    display: flex;
    /*padding: 0 1rem 2rem 1rem*/
    padding-bottom: 2rem;
  }

  .card-main .mdl-card__supporting-text .mdl-card__previus span {
    padding: 0.75rem;
  }

  .card-main .mdl-card__supporting-text .mdl-checkbox {
    /* margin-left: 2rem;
    margin-bottom: 1rem; */
  }

  .card-main .mdl-card__supporting-text .mdl-card__additional-text {
    display: flex;
    flex-direction: row;
  }

  .card-main .mdl-card__supporting-text .mdl-card__additional-text .avatar {
    width: 48px;
    height: 48px;
    margin: 10px;
    border-radius: 24px;
  }

  .card-main .mdl-card__supporting-text .mdl-card__additional-text .mdl-textfield {
    flex-grow: 2;
    /*margin: 0 2rem;*/
  }

  .card-main .mdl-card__supporting-text .revaluacion {
    /*width: 100%;*/
    margin-left: 1rem;
  }
</style>


// WEBPACK FOOTER //
// Report.vue?10017a62